<script setup lang="ts">
const { product, storeStock, close } = useReservationFormDialog()
const { layoutData, loadLayout, tooltips } = useLayout()
await loadLayout()

const { public: config } = useRuntimeConfig()
const filloutId = computed<string>(() => config?.fillout?.reservationForm || '')

const iframeKey = useState('offerFormIframeKey', () => 1)

// const { load } = useScriptFillout()

// watch (product, async (newProduct) => {
//   if (newProduct) {
//     await load()
//   }
// })

const embedCode = computed(() => {
  let script = `<`
  script += `script type="text/javascript" src="https://server.fillout.com/embed/v1/" async></`
  script += `script><div
    class="reservation-form__form"
    style="height:500px;"
    data-fillout-id="${filloutId.value}"
    data-fillout-embed-type="standard"
    data-fillout-inherit-parameters
    data-product="${product.value?.name || ''}"
    data-sku="${product.value?.sku || ''}"
    data-store="${storeStock.value?.stores?.[0].code}"
    data-fillout-dynamic-resize
    data-iframe-key="${iframeKey.value}"
  ></div>`

  return script
})

const content = computed(() => tooltips.value.get('reservation-form') || null)

const updateKey = () => {
  iframeKey.value = iframeKey.value + 1
}

onUnmounted(() => {
  close()
})
</script>

<template>
  <LazyUiDialog
    name="reservation-form-dialog"
    dialog-type="responsive"
    @close="updateKey"
  >
    <template #dialogHeader>
      <span class="dialog__title">
        {{ content?.Title || $t('Reserve product') }}
      </span>
    </template>
    <div v-if="product">
      <div class="reservation-form__header">
        <span class="product-item__name">
          {{ product?.mainTitle || product?.name || '' }}
        </span>
        <span class="product-item__brand">
          {{ product?.subTitle }}
        </span>
      </div>
      <div class="reservation-form__content">
        <StrapiBlocksText
          v-if="content"
          :nodes="content?.Richtext"
        />
        <div class="reservation-form__visual-container">
          <div class="reservation-form__image">
            <img
              v-if="product?.image"
              :src="`${product?.image}?f=rs:fit:400:400:0:0`"
              :alt="product?.name"
              width="400"
              height="291"
              loading="lazy"
            >
          </div>
          <ol
            v-if="layoutData?.reserveUsps?.[0]?.Usp?.length"
            class="reservation-form__features"
          >
            <li
              v-for="usp in layoutData?.reserveUsps?.[0]?.Usp || []"
              :key="usp"
              class="reservation-form__feature"
            >
              <span class="reservation-form__icon"> <NuxtIcon name="icon:check" /></span>
              <span>{{ usp?.Label }}</span>
            </li>
          </ol>
        </div>
      </div>

      <UiEmbed
        v-if="embedCode"
        :key="`iframeKey-${iframeKey}`"
        :embed-code="embedCode"
      />
    </div>
  </LazyUiDialog>
</template>

<style>
@import url('~layers/components/Product/ReservationFormDialog.css');
</style>
